<template>
  <wsp-modal>
    <v-card class="pb-5"
              flat>
      <v-form ref="form"
            v-model="valid"
            v-on:submit.prevent="()=> { return false }">
        <v-card-title class="pa-0">
          <v-toolbar class="primary"
                     dark
                     dense
                     flat>
            <v-toolbar-title>
              {{ $t('unsubscribe.title')}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon
                   @click="visible = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>

          <advice color="primary" class="mt-3">
            {{$t('unsubscribe.advice1')}}
          </advice>

          <advice color="warning"
                  class="mt-2">
            {{$t('unsubscribe.advice2')}}
          </advice>
        </v-card-title>

        <v-card-text>
          <v-select v-model="form.select"
                    :items="items"
                    item-text="text"
                    item-value="id"
                    return-object
                    @change="onChangeOption"
                    :rules="requiredRules"
                    :label="$t('unsubscribe.chooseOption')"
                    required></v-select>

          <v-textarea :label="$t('unsubscribe.reason')"
                      v-model="form.reason"
                      :rules="requiredTextareaRules"
                      v-if="isShowingReason">
          </v-textarea>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn round
                 flat
                 color="primary"
                 class="capitalize"
                 @click="visible = false">
            {{$t('global.button.cancel')}}
          </v-btn>

          <v-btn round
                 flat
                 color="accent"
                 class="capitalize"
                 :disabled='!valid'
                 :loading="isLoading"
                 outline
                 @click="submit">
            {{$t('global.button.send')}}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </wsp-modal>
</template>

<script>
import WspModal from '@/components/commons/WspModal';
import Advice from '@/components/commons/Advice';
import userService from '@/services/userService';
import authService from '@/services/authService';
import manageErrorService from '@/services/manageErrorService';
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';

export default {
  name: 'Unsubscribe',
  components: {
    [Advice.name]: Advice,
    [WspModal.name]: WspModal
  },
  computed: {
    requiredRules() {
      return [value => !!value || this.$i18n.t('global.validation.required.text')];
    },
    requiredTextareaRules() {
      return [
        value => !!value || this.$i18n.t('global.validation.required.text'),
        value => (!!value && value.trim().length !== 0) || this.$i18n.t('global.validation.required.text')
      ];
    }
  },
  watch: {
    visible: function(value) {
      if (!value) {
        this.$emit('on-close', {});
      }
    }
  },
  data() {
    return {
      visible: true,
      isLoading: false,
      valid: false,
      isShowingReason: false,
      items: [
        {
          id: 0,
          text: this.$i18n.t('unsubscribe.option1')
        },
        {
          id: 1,
          text: this.$i18n.t('unsubscribe.option2')
        },
        {
          id: 2,
          text: this.$i18n.t('unsubscribe.option3')
        }
      ],
      form: {
        select: null,
        reason: ''
      }
    };
  },

  methods: {
    onChangeOption(item) {
      this.isShowingReason = item.id === 2;
    },

    async submit() {
      let isValidate = await this.$refs.form.validate();
      if (!isValidate) {
        return false;
      }

      this.isLoading = true;

      let reason = this.form.reason;

      if (this.form.select !== null && this.form.select.id !== 2) {
        reason = this.form.select.text;
      }

      let payload = {
        reason: reason
      };

      let results = await userService.unsubscribe(payload);

      if (results.error) {
        manageErrorService.handle(results.data);
        this.isLoading = false;
        return;
      }

      this.isLoading = false;
      this.editMode = false;

      EventBus.$emit(keys.eventOnShowNotification, {
        title: '',
        message: this.$i18n.t('unsubscribe.toast.success'),
        type: 'info',
        doNotTranslate: true
      });

      authService.logout();
    }
  }
};
</script>
